import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListProduitsComponent } from './components/list-produits/list-produits.component';
import { AddProduitsComponent } from './components/add-produits/add-produits.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddElementsComponent } from './components/add-elements/add-elements.component';
import { MatChipsModule } from '@angular/material/chips';
import { InsertCatalogsProductComponent } from './components/insert-catalogs-product/insert-catalogs-product.component';
import { EditBasicProductInfoComponent } from './components/edit-basic-product-info/edit-basic-product-info.component';
import { EditProductPricingComponent } from './components/edit-product-pricing/edit-product-pricing.component';
import { EditProductInventoryComponent } from './components/edit-product-inventory/edit-product-inventory.component';
import { EditProductOrganizeComponent } from './components/edit-product-organize/edit-product-organize.component';
import { EditProductVariantsComponent } from './components/edit-product-variants/edit-product-variants.component';
import { DetailsProductComponent } from './components/details-product/details-product.component';
import { FilterDialogComponent } from './components/filter-dialog/filter-dialog.component';
import { EditFilesComponent } from './components/edit-files/edit-files.component';
import { InsightsComponent } from './components/product-details-inventory-tab/insights/insights.component';
import { InventoryComponent } from './components/product-details-inventory-tab/inventory/inventory.component';
import { CatalogsComponent } from './components/product-details-inventory-tab/catalogs/catalogs.component';
import { ProductInformationsComponent } from './components/details-product/product-informations/product-informations.component';
import { EditBasicProductInfosComponent } from './components/edit-product/edit-basic-product-infos/edit-basic-product-infos.component';
import { DetailsDialogueProductComponent } from './components/details-dialog-product/details-dialogue-product.component';
import { DetailsDialogEditsPricingComponent } from './components/details-dialog-edits-pricing/details-dialog-edits-pricing.component';
import { DetailsTechnicalDialogEditsComponent } from './components/details-technical-dialog-edits/details-technical-dialog-edits.component';
import { DetailsSettingDialogEditsComponent } from './components/details-setting-dialog-edits/details-setting-dialog-edits.component';
import { EditVariantProductInfosComponent } from './components/edit-product/edit-variant-product-infos/edit-variant-product-infos.component';
import { UiModule } from 'src/app/ui/ui.module';
import { EditVariantProductPricingComponent } from './components/edit-product/edit-variant-product-pricing/edit-variant-product-pricing.component';
import { EditVariantProductSettingsComponent } from './components/edit-product/edit-variant-product-settings/edit-variant-product-settings.component';
import { HandlingUnitsDialogueComponent } from './components/handling-units-dialogue/handling-units-dialogue.component';
import { DisplayTextPipe } from "../../core/pipes/display-text.pipe";
import { ObjectCustomFieldsViewComponent } from 'src/app/shared/components/object-custom-fields-view/object-custom-fields-view.component';
import { InventoryCustomFieldsComponent } from './components/inventory-custom-fields/inventory-custom-fields.component';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';



@NgModule({
  declarations: [
    ListProduitsComponent,
    AddProduitsComponent,
    AddElementsComponent,
    InsertCatalogsProductComponent,
    EditBasicProductInfoComponent,
    EditProductPricingComponent,
    EditProductInventoryComponent,
    EditProductOrganizeComponent,
    EditProductVariantsComponent,
    DetailsProductComponent,
    FilterDialogComponent,
    EditFilesComponent,
    InsightsComponent,
    InventoryComponent,
    CatalogsComponent,
    ProductInformationsComponent,
    EditBasicProductInfosComponent,
    DetailsDialogueProductComponent,
    DetailsDialogEditsPricingComponent,
    DetailsTechnicalDialogEditsComponent,
    DetailsSettingDialogEditsComponent,
    HandlingUnitsDialogueComponent,
    EditVariantProductInfosComponent,
    EditVariantProductPricingComponent,
    EditVariantProductSettingsComponent,
    InventoryCustomFieldsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    MatChipsModule,
    DisplayTextPipe,
    ObjectCustomFieldsViewComponent,
    ObjectCustomFieldsFormComponent
]
})
export class ProduitsModule { }
